import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { createSpinner } from '@syncfusion/ej2-angular-popups';
import { Browser } from '@syncfusion/ej2-base';
import { ListView } from '@syncfusion/ej2-lists';
import { Personne } from 'src/app/model/model.personne';
import { CustomLoadingService } from 'src/app/service/custom-loading.service';
import { SelectedPatientService } from 'src/app/service/selected-patient.service';
import { UserService } from 'src/app/service/user.service';
import { Context, InjectedContext } from 'src/app/shared/services/context.service';

@Component({
  selector: 'app-recherche-patient',
  templateUrl: './recherche-patient.page.html',
  styleUrls: ['./recherche-patient.page.scss'],
})
export class RecherchePatientPage implements OnInit {

  results = [];
  selectedUser = {};
  idPatient: number;
  isDesktop: boolean;
  isEmpty: boolean;
  userSelected = {};
  @Output('onIdPersonneChanged') idPersonne = new EventEmitter<any>()
  nom: string = "";
  prenom: string = "";
  email: string = "";
  Tel: string = "";
  ville: string = "";
  cdPostal: string = "";
  adresse: string = "";
  listPresonne: Personne[];
  @ViewChild('listviewInstance', { static: false }) public listviewInstance: ListView;
  public startTime: Date;
  public endTime: Date;
  public liElement: HTMLElement;
  public cssClass: string = 'e-list-template';
  public template: string = '<div class="e-list-wrapper e-list-avatar" (click)="clickNew($event)">' +
    '<span class="e-list-content">${per_nom} ${per_prenom}</span></div>';

  public ddlFields: Object = { text: 'text', value: 'value' };
  public fields: Object = { text: 'per_nom' };
  public searchFields = [
    {
      idField: 'lastName',
      placeholder: 'Nom',
    },
    {
      idField: 'firstName',
      placeholder: 'Prénom',
    },
    {
      idField: 'email',
      placeholder: 'Email',
    },
    {
      idField: 'tel',
      placeholder: 'Tel',
    },
    // {
    //   idField: 'city',
    //   placeholder: 'Ville',
    // },
    // {
    //   idField: 'postalCode',
    //   placeholder: 'Code Postal',
    // },
    // {
    //   idField: 'address',
    //   placeholder: 'Adresse',
    // },
  ];
  currentUser: any;
  praticien: any;

  constructor(
    private userService: UserService,
    public modalCtrl: ModalController,
    private context: Context,
    private navctrl: NavController,
    private router: Router,
    private customLoadingService: CustomLoadingService,
    private selectedPatientService: SelectedPatientService

  ) {
    this.isDesktop = this.context.detectPlatformDesktop();
  }
  
  ngOnInit() {
    this.liElement = document.getElementById('ui-list');
    if (this.liElement) {
      if (Browser.isDevice) {
        this.liElement.classList.add('ui-mobile');
      }

      createSpinner({
        target: this.liElement
      });
    }
    var value = localStorage.getItem("currentUser");
        this.currentUser = JSON.parse(value);
    //    console.log(this.currentUser);
        this.praticien = this.currentUser.id;
  }

isSuperAdmin(): boolean {
  if (!this.currentUser || !this.currentUser.authorities) return false;
  return this.currentUser.authorities.some((auth: any) => auth.name === 'ROLE_SUPER_ADMIN');
}

  ionChange(args: any) {
    switch (args.target.id) {
      case "lastName":
        this.nom = args.detail.value;
        break;
      case "firstName":
        this.prenom = args.detail.value;
        break;
      case "tel":
        this.Tel = args.detail.value;
        break;
      case "city":
        this.ville = args.detail.value;
        break;
      case "postalCode":
        this.cdPostal = args.detail.value;
        break;
      case "address":
        this.adresse = args.detail.value;
        break;
      case "email":
        this.email = args.detail.value;
        break;
    }
    this.loadData();
    localStorage.setItem('DiagCheck', "1");
    localStorage.removeItem('IdDiagnostic');
  }
async loadData() {
    this.isEmpty = false;
    if (!this.nom && !this.prenom && !this.email && !this.Tel && !this.ville && !this.cdPostal && !this.adresse) {
      this.results = [];
      return;
    }
    const praticienId = this.isSuperAdmin() ? null : this.praticien;
    await this.userService.getAllPatientsV2(
      this.nom, this.prenom, this.email,
      this.Tel, this.ville, this.cdPostal, this.adresse,
      praticienId
    ).subscribe(res => {
      this.results = res;
      this.isEmpty = this.results.length === 0;
    });
  }

  getIdPersonne(idPersonne : any) {
    this.idPersonne.emit(idPersonne);
  }

  onIdPersonneChanged($event : any) {
    this.idPersonne = $event;
    localStorage.setItem("idPatient", this.idPersonne.toString())
  }
  
  async loadUserMobile(idPersonne: any) {
    this.onIdPersonneChanged(idPersonne)
    this.selectedPatientService.setSelectedPatientId(Number(idPersonne));
    this.customLoadingService.presentLoading().then(async value => {
        InjectedContext.picturePatient = []    
        this.customLoadingService.dismissLoading();
        this.modalCtrl.dismiss(idPersonne);
        
    });
  }


  getUserSelected(idPersonne : any) {
    this.userService.getUserById(idPersonne)
      .subscribe((userObject) => {
        this.userSelected = userObject["per_nom"] + " " + userObject["per_prenom"];
      });
  }
}